<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          You are about to logoff
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn
            color="primary"
            text
            @click="closeDialogAndResetLoginInterval"
          >
            cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="logout"
          >
            Log-out anyway
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { EventBus } from '../../main.js'
  export default {
    props: ['dialog'],
    methods:{
        closeDialogAndResetLoginInterval(){
            this.$emit('closeDialog')
            EventBus.$emit('logoutEvent', 'logout');
        },
        logout(){
            localStorage.removeItem("lastTimeStamp");
            localStorage.removeItem('user_id')
            localStorage.removeItem('email')
            localStorage.removeItem('access_token')
            localStorage.removeItem('password')
            localStorage.removeItem('name')
            localStorage.removeItem('syndication_id')
            this.$emit('closeDialog')
            this.$router.push('/login');
        }
    }
  }
</script>